/**
 * mcycle homepage hot list module
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/11
 */
import './index.css';
import React, { Component } from 'react';
import ProductItem from '../productList/productItem/productItem';

class HotList extends Component {
  render() {
    return (
      <div className="mcycle-home-hot">
        <div className="mcycle-home-hot-title"><p>热门回收</p></div>
        <ul className="mcycle-homt-hot-list clearfix">
          {
            this.props.hot.map((item, index) => (
              <ProductItem id={ item.id } link={ item.imageUrl } name={ item.name } price={ item.price } key={ index } />
            ))
          }
        </ul>
      </div>
    )
  }
}

export default HotList


// WEBPACK FOOTER //
// ./src/components/home/hotList/index.js